import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom';

import AppContainer from '../../containers/App';
import Loading from '../../components/site/Loading';

import UtilsService from '../../services/utils';


interface RedirectProps {
  match?: any;
  location?: any;
  history?: any;
}

const Redirect: React.FC<RedirectProps> = (props) => {
  
  useEffect(() => {
    
    console.log('props', props);

    const url = UtilsService.getParameterByName('url', props.location.search);

    if (url) {  
      props.history.push(url);
    }

    console.log('url', url);

  }, []);

  return (
    <AppContainer showOption={false} private={false} maxWidth="xl">
      <Loading open />
    </AppContainer>
  )
}
export default withRouter<any, any>(Redirect);

const styles: any = {
  notFound: {
    fontSize: 48,
    textAlign: 'center',
    padding: 40
  },
}


// WEBPACK FOOTER //
// ./src/pages/home/Redirect.tsx